import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';

// ── RequireModule — RET-10 (D-RR-SURFACES-MODULE-GATED): the client half of a module gate ──────────────────────
// A layout route: its child routes render only for a tenant entitled to `module`. Otherwise it renders the inline
// "not enabled" state in place — NO redirect (the URL the user typed stays put, so it is clear what was refused) and
// NO API call (the page, and so its data hooks, never mount). The api enforces the same gate per request; this is the
// UX half, so a typed URL never renders a page whose api answers 403. Reusable for B-CUSTOMER-ROUTES-NO-MODULE-GUARD.
//   <Route element={<RequireModule module="compliance" />}> … </Route>

const MODULE_LABEL: Record<string, string> = {
  compliance: 'Compliance',
  vrm: 'Vendor Risk Management',
};

export function RequireModule({ module }: { module: string }) {
  const entitledModules = useAuthStore((s) => s.entitledModules);
  if (entitledModules.includes(module)) return <Outlet />;
  const label = MODULE_LABEL[module] ?? module;
  return (
    <div className="flex flex-col items-center gap-[7px] px-6 py-[52px] text-center" data-testid="module-not-enabled">
      <span className="text-[13px] font-semibold text-text-muted">{label} is not enabled</span>
      <span className="max-w-[48ch] text-[12px] leading-[1.6] text-text-faint">
        This page is part of the {label} module, which is not enabled for your organization.
      </span>
    </div>
  );
}
